.u{align-items:center;}